import { render } from "./ConceptView.vue?vue&type=template&id=df651ac4&scoped=true"
import script from "./ConceptView.vue?vue&type=script&lang=js"
export * from "./ConceptView.vue?vue&type=script&lang=js"

import "./ConceptView.vue?vue&type=style&index=0&id=df651ac4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df651ac4"]])

export default __exports__